module.exports = __webpack_public_path__ + "img/smart-plug.ac3a1db9.svg";